import(/* webpackMode: "eager" */ "/home/jenkins/deployment/obituary-app/staging-fe/obituary-app-fe/app/error.js");
